import { render, staticRenderFns } from "./ContentFeedView.vue?vue&type=template&id=042c40e2&"
import script from "./ContentFeedView.vue?vue&type=script&lang=ts&"
export * from "./ContentFeedView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports